// #region IMPORTS
import { useEffect } from 'react';
import { useSnapshot } from 'valtio';

import { BVHLoader } from '@cartwhl/3d/bvh';

import { animationGenerationStore, posingStore } from 'stores';

import { DEFAULT_IK_CHAIN } from './constants';

// #endregion

export default function PoseEffects() {
  // #region DATA
  const { poseRenderInformation } = useSnapshot(posingStore.state);
  // #endregion

  // #region LOAD BVH POSE
  // Triggered by Pose Library & Project Loading

  const bvhUrl = poseRenderInformation?.bvhURL;

  useEffect(() => {
    if (!bvhUrl) return;
    console.log('PoseEffects - BVH Pose initiating download');

    animationGenerationStore.setLoading('animation', true);

    fetchAndLoadPose(bvhUrl)
      .catch((e) => console.error('PoseEffects - Error loading BVH Pose', e))
      .finally(() => animationGenerationStore.setLoading('animation', false));
  }, [bvhUrl]);
  // #endregion

  return <></>;
}

// #region HELPERS

/** Download a pose BVH then pass it to poser */
async function fetchAndLoadPose(url: string) {
  const loader = new BVHLoader().setWithCredentials(true);

  // TODO - preodically check if types gets updated with loadAsync
  // @ts-expect-error loadAsync exists, threejs types does not have it defined
  const bvh = await loader.loadAsync(url);

  // Load pose
  if (posingStore.state.posingSystem.current?.poser.setPoseFromClip(bvh.clip)) {
    posingStore.state.posingSystem.current?.fitViewActiveCharacter();

    // Pre-select IK Chain with a slight delay for react state to trigger correctly
    queueMicrotask(() => (posingStore.state.activeIKChain = DEFAULT_IK_CHAIN));

    console.log('fetchAndLoadPose - BVH Pose downloaded & loaded');
  }
}

// #endregion
